module.exports = __webpack_public_path__ + "static/img/login01_03.08a5075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_03.png
// module id = a2su
// module chunks = 0